<input #inputEl type="search" [placeholder]="placeholder" [value]="value" (input)="onInput($event)" />
